import React, { Component } from 'react';
import Fa from 'react-fontawesome';

class LoadingRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Fa name="spinner" spin className="text-muted" />
    );
  }
}

LoadingRenderer.propTypes = {
};
LoadingRenderer.defaultProps = {
};

export default LoadingRenderer;
